export default __webpack_public_path__ + "static/media/AvenirNextW04-Demi.53222096.ttf";